import React from 'react';

const ImageAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 40 40" fill="blue" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0457 8.95429 40 20 40Z"
      fill={props.color || '#ED72E2'}
    />
    <path
      opacity="0.5"
      d="M31.0219 26.3636L20.0001 32.7272L8.97827 26.3636V13.6363L20.0001 7.27271L31.0219 13.6363V26.3636Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M16.4001 23.6C18.3892 25.5891 21.611 25.5891 23.6001 23.6C23.8619 23.3382 24.0837 23.0582 24.2765 22.76L31.0219 13.6363L20.0001 7.27271L8.97827 13.6363L15.7237 22.76C15.9165 23.0582 16.1419 23.3382 16.4001 23.6Z"
      fill="white"
    />
    <path
      opacity="0.25"
      d="M23.6001 16.4C21.611 14.4109 18.3892 14.4109 16.4001 16.4C16.1383 16.6618 15.9165 16.9418 15.7237 17.24L8.97827 26.3637L20.0001 32.7273L31.0219 26.3637L24.2765 17.24C24.0837 16.9418 23.8583 16.6618 23.6001 16.4Z"
      fill="white"
    />
    <path
      d="M24.2763 17.24C24.0836 16.9418 23.8618 16.6618 23.6 16.4C21.6109 14.4109 18.389 14.4109 16.4 16.4C16.1381 16.6618 15.9163 16.9418 15.7236 17.24L13.6836 20L15.7236 22.76C15.9163 23.0582 16.1381 23.3382 16.4 23.6C18.389 25.5891 21.6109 25.5891 23.6 23.6C23.8618 23.3382 24.0836 23.0582 24.2763 22.76L26.3163 20L24.2763 17.24Z"
      fill="white"
    />
    <path
      d="M20 22.5455C21.4059 22.5455 22.5455 21.4059 22.5455 20C22.5455 18.5942 21.4059 17.4546 20 17.4546C18.5942 17.4546 17.4546 18.5942 17.4546 20C17.4546 21.4059 18.5942 22.5455 20 22.5455Z"
      fill={props.color || '#ED72E2'}
    />
  </svg>
);

export default ImageAnnotationIcon;
